export function refreshAccessTokenUsecaseFactory(deps) {
    return async () => {
        return (await deps.authRepository.refreshUserAuth0Token()).accessToken;
    };
}
//# sourceMappingURL=refresh-access-token.usecase.js.map